export default "__VITE_ASSET__D_tydCH6__"